import React from 'react';
import Modal from '@material-ui/core/Modal';
import Loading from 'components/Loading';


export default function LoadingModal(props) {
  const { isLoading } = props;

  return (
    <Modal
      open={isLoading}
      style={{top: "50%", left:"50%"}}
    >
      <div>
        <Loading />
      </div>
    </Modal>
  );
}
